//#region src/vitrine_menu_cover_orientation.ts
let MenuCoverType = /* @__PURE__ */ function(MenuCoverType) {
	MenuCoverType["Gcn"] = "gcn";
	MenuCoverType["VitrinePortrait"] = "vitrine-portrait";
	MenuCoverType["VitrineLandscape"] = "vitrine-landscape";
	return MenuCoverType;
}({});
//#endregion
export { MenuCoverType };

//# sourceMappingURL=vitrine_menu_cover_orientation.js.map